/**
 * B2B Wholesale Order Page — b2b-order-search2.js
 *
 * 左サイドバー チェックボックス版フィルター
 * (b2b-order-search.js のピルボタンをチェックボックスに置き換えたバージョン)
 */

(function () {
  'use strict';

  /* ── Config ─────────────────────────────────────────────── */
  const config = window.B2B_CONFIG || {
    discountRate: 30,
    currency: 'JPY',
    moneyFormat: '¥{{amount}}',
    pageTitle: 'WHOLESALE ORDER'
  };

  /* ── DOM references ──────────────────────────────────────── */
  const page           = document.querySelector('.b2b-page');
  const cartBar        = document.getElementById('b2b-cart-bar');
  const totalItems     = document.getElementById('b2b-total-items');
  const totalPrice     = document.getElementById('b2b-total-price');
  const addBtn         = document.getElementById('b2b-add-to-cart');
  const modal          = document.getElementById('b2b-modal');
  const modalClose     = document.getElementById('b2b-modal-close');
  const summaryEl      = document.getElementById('b2b-order-summary');
  const summaryItemsEl = document.getElementById('b2b-summary-items');
  const summaryTotalEl = document.getElementById('b2b-summary-total');
  const categoryChecks = document.getElementById('b2b-category-checks');

  if (!page) return;

  const discountRate = parseInt(page.dataset.discount, 10) || config.discountRate;

  /* ── Format money ────────────────────────────────────────── */
  function formatMoney(cents) {
    if (config.currency === 'JPY') {
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }
    const amount = Math.round(cents) / 100;
    return config.moneyFormat.replace('{{amount}}', amount.toFixed(2));
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Stepper helpers ─────────────────────────────────────── */
  function getValue(input) {
    return Math.max(0, parseInt(input.value, 10) || 0);
  }

  function setValue(input, val) {
    input.value = Math.max(0, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ── Row subtotal ────────────────────────────────────────── */
  function updateRowSubtotal(row) {
    const price  = parseInt(row.dataset.price, 10) || 0;
    const inputs = row.querySelectorAll('.b2b-stepper__input');
    let rowQty   = 0;
    inputs.forEach(function (inp) { rowQty += getValue(inp); });

    // subtotalは兄弟のb2b-subtotal-row内にある
    var subtotalRow = row.nextElementSibling;
    while (subtotalRow && !subtotalRow.classList.contains('b2b-subtotal-row')) {
      subtotalRow = subtotalRow.nextElementSibling;
    }
    var sub = subtotalRow ? subtotalRow.querySelector('[data-row-subtotal]') : row.querySelector('[data-row-subtotal]');
    if (sub) sub.textContent = formatMoney(price * rowQty);

    row.classList.toggle('has-qty', rowQty > 0);
  }

  /* ── Grand total ─────────────────────────────────────────── */
  function updateGrandTotal() {
    const rows     = document.querySelectorAll('.b2b-row');
    let grandCents = 0;
    let grandQty   = 0;

    rows.forEach(function (row) {
      const price  = parseInt(row.dataset.price, 10) || 0;
      const inputs = row.querySelectorAll('.b2b-stepper__input');
      inputs.forEach(function (inp) {
        const qty   = getValue(inp);
        grandQty   += qty;
        grandCents += price * qty;
      });
    });

    totalItems.textContent = grandQty;
    totalPrice.textContent = formatMoney(grandCents);

    const visible = grandQty > 0;
    cartBar.classList.toggle('is-visible', visible);
    cartBar.setAttribute('aria-hidden', String(!visible));
  }

  /* ── Attach stepper events ───────────────────────────────── */
  function attachStepperEvents(rows) {
    rows.forEach(function (row) {
      row.querySelectorAll('.b2b-size-item__stepper').forEach(function (stepper) {
        const upBtn   = stepper.querySelector('.b2b-stepper__btn--up');
        const downBtn = stepper.querySelector('.b2b-stepper__btn--down');
        const input   = stepper.querySelector('.b2b-stepper__input');
        if (!input) return;

        const stock          = parseInt(input.dataset.stock, 10);
        const tracksInventory = input.dataset.tracksInventory === 'true';

        function clamp(v) {
          v = Math.max(0, v);
          if (tracksInventory && !isNaN(stock)) v = Math.min(stock, v);
          return v;
        }

        if (upBtn) upBtn.addEventListener('click', function () {
          const n = clamp(getValue(input) + 1);
          setValue(input, n);
          if (tracksInventory && !isNaN(stock)) upBtn.disabled = n >= stock;
          if (downBtn) downBtn.disabled = false;
        });

        if (downBtn) downBtn.addEventListener('click', function () {
          const n = clamp(getValue(input) - 1);
          setValue(input, n);
          if (upBtn && tracksInventory && !isNaN(stock)) upBtn.disabled = n >= stock;
          downBtn.disabled = n <= 0;
        });

        input.addEventListener('input', function () {
          const n = clamp(getValue(input));
          input.value = n;
          if (upBtn && tracksInventory && !isNaN(stock)) upBtn.disabled = n >= stock;
          if (downBtn) downBtn.disabled = n <= 0;
          updateRowSubtotal(row);
          updateGrandTotal();
        });

        input.addEventListener('change', function () {
          updateRowSubtotal(row);
          updateGrandTotal();
        });
      });
    });
  }

  /* Initial attachment */
  attachStepperEvents(Array.from(document.querySelectorAll('.b2b-row')));

  /* ── Multi-select filter state ──────────────────────────── */
  const selectedCollections = new Set(); // 空 = 全表示
  const selectedTypes       = new Set(); // 空 = 全表示

  function applyFilters() {
    document.querySelectorAll('.b2b-row').forEach(function (row) {
      const col  = row.dataset.collection || '';
      const type = (row.dataset.type || '').trim();
      const colMatch  = selectedCollections.size === 0 || selectedCollections.has(col);
      const typeMatch = selectedTypes.size === 0       || selectedTypes.has(type);
      const hidden = !colMatch || !typeMatch;
      row.classList.toggle('is-hidden', hidden);
      const subtotalRow = row.nextElementSibling;
      if (subtotalRow && subtotalRow.classList.contains('b2b-subtotal-row')) {
        subtotalRow.style.display = hidden ? 'none' : '';
        const spacerRow = subtotalRow.nextElementSibling;
        if (spacerRow && spacerRow.classList.contains('b2b-spacer-row')) {
          spacerRow.style.display = hidden ? 'none' : '';
        }
      }
    });
  }

  /* ── Collection preview image ────────────────────────────── */
  const ALL_COL_IMAGE  = 'https://cdn.shopify.com/s/files/1/0525/2317/2040/files/banner-chicken.jpg?v=1783489482';
  const colPreviewImg  = document.getElementById('b2b-col-preview');
  const colAllChk      = document.querySelector('.b2b-sidebar__check[data-collection="__all__"]');

  function updateColPreview(clickedChk) {
    if (!colPreviewImg) return;
    if (selectedCollections.size === 0) {
      colPreviewImg.src = ALL_COL_IMAGE;
    } else {
      const img = clickedChk && clickedChk.dataset.img ? clickedChk.dataset.img : null;
      if (img) colPreviewImg.src = img;
    }
  }

  /* ── Collection checkboxes ───────────────────────────────── */
  document.querySelectorAll('.b2b-sidebar__check[data-collection]').forEach(function (chk) {
    chk.addEventListener('change', function () {
      const col = chk.dataset.collection;

      if (col === '__all__') {
        /* ALL → 全解除、ALLをchecked固定 */
        selectedCollections.clear();
        document.querySelectorAll('.b2b-sidebar__check[data-collection]:not([data-collection="__all__"])').forEach(function (c) {
          c.checked = false;
        });
        chk.checked = true;
        updateColPreview(null);
      } else {
        if (chk.checked) {
          /* 他のコレクションを全解除（ラジオボタン的に1つだけ選択） */
          selectedCollections.clear();
          document.querySelectorAll('.b2b-sidebar__check[data-collection]:not([data-collection="__all__"])').forEach(function (c) {
            if (c !== chk) c.checked = false;
          });
          selectedCollections.add(col);
          if (colAllChk) colAllChk.checked = false;
          updateColPreview(chk);
        } else {
          /* チェックを外したらALLに戻る */
          selectedCollections.clear();
          if (colAllChk) colAllChk.checked = true;
          updateColPreview(null);
        }
      }

      applyFilters();
      buildCategoryChecks();
    });
  });

  /* ── Dynamic category checkboxes ────────────────────────── */
  function buildCategoryChecks() {
    if (!categoryChecks) return;

    /* Collectionフィルターで絞り込まれた行だけを集計 */
    const typeCounts = {};
    document.querySelectorAll('.b2b-row').forEach(function (row) {
      const col      = row.dataset.collection || '';
      const colMatch = selectedCollections.size === 0 || selectedCollections.has(col);
      if (!colMatch) return;
      const t = (row.dataset.type || '').trim();
      if (!t) return;
      typeCounts[t] = (typeCounts[t] || 0) + 1;
    });

    const totalCount = Object.values(typeCounts).reduce(function (s, n) { return s + n; }, 0);
    const allChecked = selectedTypes.size === 0 ? ' checked' : '';

    /* ALLチェックボックス */
    let html =
      '<label class="b2b-sidebar__item">' +
      '<input class="b2b-sidebar__check b2b-sidebar__check--cat" type="checkbox"' +
      ' data-type="__all__"' + allChecked + '>' +
      '<span class="b2b-sidebar__label">ALL' +
      '<span class="b2b-sidebar__count">' + totalCount + '</span>' +
      '</span>' +
      '</label>';

    /* 各カテゴリー */
    Object.keys(typeCounts).forEach(function (type) {
      const checked = selectedTypes.has(type) ? ' checked' : '';
      html +=
        '<label class="b2b-sidebar__item">' +
        '<input class="b2b-sidebar__check b2b-sidebar__check--cat" type="checkbox"' +
        ' data-type="' + escHtml(type) + '"' + checked + '>' +
        '<span class="b2b-sidebar__label">' + escHtml(type).toUpperCase() +
        '<span class="b2b-sidebar__count">' + typeCounts[type] + '</span>' +
        '</span>' +
        '</label>';
    });

    categoryChecks.innerHTML = html;

    /* 再生成後にイベント付与 */
    categoryChecks.querySelectorAll('.b2b-sidebar__check--cat').forEach(function (chk) {
      chk.addEventListener('change', function () {
        const type   = chk.dataset.type;
        const allChk = categoryChecks.querySelector('[data-type="__all__"]');

        if (type === '__all__') {
          /* ALL → 全解除、ALLをchecked固定 */
          selectedTypes.clear();
          categoryChecks.querySelectorAll('.b2b-sidebar__check--cat').forEach(function (c) {
            c.checked = c === chk;
          });
        } else {
          if (chk.checked) {
            /* 他を全解除（1つだけ選択） */
            selectedTypes.clear();
            categoryChecks.querySelectorAll('.b2b-sidebar__check--cat').forEach(function (c) {
              if (c !== chk) c.checked = false;
            });
            selectedTypes.add(type);
            if (allChk) allChk.checked = false;
          } else {
            /* チェックを外したらALLに戻る */
            selectedTypes.clear();
            if (allChk) allChk.checked = true;
          }
        }
        applyFilters();
      });
    });
  }

  buildCategoryChecks();

  /* ── Sidebar sticky top offset ───────────────────────────── */
  function updateSidebarTop() {
    const stickyTop = document.querySelector('.b2b-sticky-top');
    const sidebar   = document.getElementById('b2b-sidebar');
    if (!stickyTop || !sidebar) return;
    const h = stickyTop.getBoundingClientRect().height;
    sidebar.style.top = h + 'px';
  }

  updateSidebarTop();
  window.addEventListener('resize', updateSidebarTop);

  /* ── Infinite scroll ─────────────────────────────────────── */
  (function initInfiniteScroll() {
    const nextPageEl = document.getElementById('b2b-next-page');
    if (!nextPageEl) return;

    const tbody    = document.querySelector('.b2b-table__body');
    const sentinel = document.createElement('tr');
    sentinel.style.height = '1px';
    tbody && tbody.appendChild(sentinel);

    let nextUrl   = nextPageEl.dataset.url;
    let isLoading = false;

    async function loadMore() {
      if (!nextUrl || isLoading) return;
      isLoading = true;

      try {
        const res  = await fetch(nextUrl);
        const text = await res.text();
        const doc  = new DOMParser().parseFromString(text, 'text/html');
        const rows = Array.from(doc.querySelectorAll('.b2b-row'));

        rows.forEach(function (r) { tbody.insertBefore(r, sentinel); });
        attachStepperEvents(rows);
        rows.forEach(function (row) { attachImageClicks(row); attachGalleryBtns(row); });

        buildCategoryChecks();
        applyFilters();

        const next = doc.getElementById('b2b-next-page');
        nextUrl = next ? next.dataset.url : null;
        if (!nextUrl) observer.disconnect();
      } catch (e) {
        console.error('[B2B] Infinite scroll error:', e);
      } finally {
        isLoading = false;
      }
    }

    const observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadMore();
    }, { rootMargin: '400px' });

    observer.observe(sentinel);
  })();

  /* ── Build order summary HTML ────────────────────────────── */
  function buildSummaryHTML() {
    const rows = document.querySelectorAll('.b2b-row');
    const lines = [];
    let grandCents = 0;
    let grandQty   = 0;

    rows.forEach(function (row) {
      const price   = parseInt(row.dataset.price, 10) || 0;
      const nameEl  = row.querySelector('.b2b-product-info__name');
      const skuEl   = row.querySelector('.b2b-product-info__sku');
      const name    = nameEl ? nameEl.textContent.trim() : '';
      const sku     = skuEl  ? skuEl.textContent.trim()  : '';

      row.querySelectorAll('.b2b-stepper__input').forEach(function (inp) {
        const qty = getValue(inp);
        if (qty <= 0) return;

        const sizeItem = inp.closest('.b2b-size-item');
        const labelEl  = sizeItem ? sizeItem.querySelector('.b2b-size-item__label') : null;
        const size     = labelEl ? labelEl.textContent.trim() : '';
        const barcode  = inp.dataset.barcode || '';
        const subtotal = price * qty;

        grandCents += subtotal;
        grandQty   += qty;

        lines.push(
          '<tr>' +
          '<td><div class="b2b-summary__name">' + escHtml(name) + '</div>' +
          '<div class="b2b-summary__upc">SKU: ' + escHtml(sku) +
          (barcode ? ' &nbsp;|&nbsp; UPC: ' + escHtml(barcode) : '') + '</div></td>' +
          '<td>' + escHtml(size) + '</td>' +
          '<td>' + formatMoney(price) + '</td>' +
          '<td style="text-align:center">' + qty + '</td>' +
          '<td style="text-align:right">' + formatMoney(subtotal) + '</td>' +
          '</tr>'
        );
      });
    });

    if (!lines.length) return { html: '', grandCents: 0, grandQty: 0 };

    const html =
      '<table class="b2b-summary-table">' +
      '<thead><tr>' +
      '<th>PRODUCT</th><th>SIZE</th><th>WHOLESALE</th>' +
      '<th style="text-align:center">QTY</th><th style="text-align:right">SUBTOTAL</th>' +
      '</tr></thead>' +
      '<tbody>' + lines.join('') + '</tbody>' +
      '</table>';

    return { html: html, grandCents: grandCents, grandQty: grandQty };
  }

  /* ── Validation ──────────────────────────────────────────── */
  const footerEl      = document.getElementById('b2b-modal-footer');
  const sentEl        = document.getElementById('b2b-modal-sent');
  const shareBtn      = document.getElementById('b2b-share-btn');
  const sentCloseBtn  = document.getElementById('b2b-modal-sent-close');
  const modalCustomer = document.getElementById('b2b-modal-customer');
  const inputName     = document.getElementById('b2b-input-name');
  const inputContact  = document.getElementById('b2b-input-contact');
  const errorName     = document.getElementById('b2b-error-name');
  const errorContact  = document.getElementById('b2b-error-contact');

  function getCustomerName()    { return inputName    ? inputName.value.trim()    : ''; }
  function getCustomerContact() { return inputContact ? inputContact.value.trim() : ''; }

  function validateInputs() {
    let valid = true;

    if (!getCustomerName()) {
      if (inputName)  inputName.classList.add('is-error');
      if (errorName)  { errorName.classList.add('is-visible'); errorName.setAttribute('aria-hidden', 'false'); }
      valid = false;
    } else {
      if (inputName)  inputName.classList.remove('is-error');
      if (errorName)  { errorName.classList.remove('is-visible'); errorName.setAttribute('aria-hidden', 'true'); }
    }

    if (!getCustomerContact()) {
      if (inputContact) inputContact.classList.add('is-error');
      if (errorContact) { errorContact.classList.add('is-visible'); errorContact.setAttribute('aria-hidden', 'false'); }
      valid = false;
    } else {
      if (inputContact) inputContact.classList.remove('is-error');
      if (errorContact) { errorContact.classList.remove('is-visible'); errorContact.setAttribute('aria-hidden', 'true'); }
    }

    if (!valid && inputName && !getCustomerName()) inputName.focus();
    else if (!valid && inputContact && !getCustomerContact()) inputContact.focus();

    return valid;
  }

  inputName && inputName.addEventListener('input', function () {
    if (getCustomerName()) {
      inputName.classList.remove('is-error');
      if (errorName) { errorName.classList.remove('is-visible'); errorName.setAttribute('aria-hidden', 'true'); }
    }
  });
  inputContact && inputContact.addEventListener('input', function () {
    if (getCustomerContact()) {
      inputContact.classList.remove('is-error');
      if (errorContact) { errorContact.classList.remove('is-visible'); errorContact.setAttribute('aria-hidden', 'true'); }
    }
  });

  /* ── Modal ───────────────────────────────────────────────── */
  function showModal() {
    if (!modal) return;
    if (footerEl) footerEl.style.display = '';
    if (sentEl)   { sentEl.classList.remove('is-visible'); sentEl.setAttribute('aria-hidden', 'true'); }
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    if (!modal) return;
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showSentMessage() {
    if (footerEl) footerEl.style.display = 'none';
    if (sentEl)   { sentEl.classList.add('is-visible'); sentEl.setAttribute('aria-hidden', 'false'); }
  }

  if (modalClose)   modalClose.addEventListener('click', hideModal);
  if (sentCloseBtn) sentCloseBtn.addEventListener('click', hideModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) hideModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape')      { closeLightbox(); hideModal(); }
    if (e.key === 'ArrowLeft')   { lbPrev(); }
    if (e.key === 'ArrowRight')  { lbNext(); }
  });

  /* ── Build share text ────────────────────────────────────── */
  function buildShareText() {
    const rows  = document.querySelectorAll('.b2b-row');
    const lines = [];
    const now   = new Date().toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });

    lines.push('【B2B WHOLESALE ORDER】');
    lines.push(config.pageTitle);
    lines.push(now);
    if (getCustomerName())    lines.push('氏名/店名: ' + getCustomerName());
    if (getCustomerContact()) lines.push('連絡先: '   + getCustomerContact());
    lines.push('割引: ' + discountRate + '% OFF');
    lines.push('');

    let grandCents = 0;
    let grandQty   = 0;

    rows.forEach(function (row) {
      const price  = parseInt(row.dataset.price, 10) || 0;
      const nameEl = row.querySelector('.b2b-product-info__name');
      const skuEl  = row.querySelector('.b2b-product-info__sku');
      const name   = nameEl ? nameEl.textContent.trim() : '';
      const sku    = skuEl  ? skuEl.textContent.trim()  : '';
      const sizeLines = [];
      let rowQty = 0;

      row.querySelectorAll('.b2b-stepper__input').forEach(function (inp) {
        const qty = getValue(inp);
        if (qty <= 0) return;
        const sizeItem = inp.closest('.b2b-size-item');
        const labelEl  = sizeItem ? sizeItem.querySelector('.b2b-size-item__label') : null;
        const size     = labelEl ? labelEl.textContent.trim() : '';
        const barcode  = inp.dataset.barcode || '';
        sizeLines.push('  ' + size + ' × ' + qty + (barcode ? ' (UPC:' + barcode + ')' : ''));
        rowQty     += qty;
        grandCents += price * qty;
        grandQty   += qty;
      });

      if (sizeLines.length) {
        lines.push(name + (sku ? ' [' + sku + ']' : ''));
        lines.push('  卸値: ' + formatMoney(price));
        sizeLines.forEach(function (l) { lines.push(l); });
        lines.push('  小計: ' + formatMoney(price * rowQty));
        lines.push('');
      }
    });

    lines.push('━━━━━━━━━━━━━━━━');
    lines.push('合計 ' + grandQty + ' points　' + formatMoney(grandCents));

    return { text: lines.join('\n'), grandQty: grandQty, grandCents: grandCents };
  }

  /* ── Discord Webhook ─────────────────────────────────────── */
  const DISCORD_WEBHOOK = 'https://discord.com/api/webhooks/1516374636634574888/iiButgS0rvBC9NsOsm2S6uLBAXpaXA67RoeMozenDNE7XadE-JdG5vBKcFVEu44SeuHi';

  async function sendToDiscord(text) {
    const LIMIT   = 1900;
    const chunks  = [];
    let remaining = text;
    while (remaining.length > 0) {
      if (remaining.length <= LIMIT) { chunks.push(remaining); break; }
      let cut = remaining.lastIndexOf('\n', LIMIT);
      if (cut <= 0) cut = LIMIT;
      chunks.push(remaining.slice(0, cut));
      remaining = remaining.slice(cut).trimStart();
    }
    for (const chunk of chunks) {
      await fetch(DISCORD_WEBHOOK, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ content: '```\n' + chunk + '\n```' })
      });
    }
  }

  shareBtn && shareBtn.addEventListener('click', async function () {
    const share = buildShareText();
    if (!share.grandQty) return;
    shareBtn.disabled = true;
    shareBtn.textContent = '送信中…';
    try {
      await sendToDiscord(share.text);
      showSentMessage();
    } catch (err) {
      console.error('[B2B] Discord send failed:', err);
      alert('送信に失敗しました。もう一度お試しください。\n' + err.message);
    } finally {
      shareBtn.disabled = false;
      shareBtn.textContent = 'SHARE ORDER';
    }
  });

  /* ── SEND ORDER ──────────────────────────────────────────── */
  addBtn && addBtn.addEventListener('click', function () {
    if (!validateInputs()) return;
    const result = buildSummaryHTML();
    if (!result.grandQty) return;

    if (summaryEl)      summaryEl.innerHTML = result.html;
    if (summaryItemsEl) summaryItemsEl.textContent = result.grandQty + ' items';
    if (summaryTotalEl) summaryTotalEl.textContent = 'TOTAL  ' + formatMoney(result.grandCents);

    if (modalCustomer) {
      modalCustomer.innerHTML =
        '<p class="b2b-modal__customer-name">' + escHtml(getCustomerName()) + '</p>' +
        '<p class="b2b-modal__customer-email">' + escHtml(getCustomerContact()) + '</p>';
    }
    showModal();
  });

  /* ── Slideshow Lightbox ──────────────────────────────────── */
  let lbGallery = [];
  let lbIndex   = 0;

  const overlay = document.createElement('div');
  overlay.className = 'b2b-lightbox';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.setAttribute('role', 'dialog');

  const lbCloseBtn = document.createElement('button');
  lbCloseBtn.className = 'b2b-lightbox__close';
  lbCloseBtn.textContent = '×';
  lbCloseBtn.setAttribute('aria-label', 'Close');

  const lbPrevBtn = document.createElement('button');
  lbPrevBtn.className = 'b2b-lightbox__nav b2b-lightbox__nav--prev';
  lbPrevBtn.textContent = '‹';
  lbPrevBtn.setAttribute('aria-label', 'Previous');

  const lbNextBtn = document.createElement('button');
  lbNextBtn.className = 'b2b-lightbox__nav b2b-lightbox__nav--next';
  lbNextBtn.textContent = '›';
  lbNextBtn.setAttribute('aria-label', 'Next');

  const lbImg = document.createElement('img');
  lbImg.className = 'b2b-lightbox__img';
  lbImg.alt = '';

  const lbCounter = document.createElement('p');
  lbCounter.className = 'b2b-lightbox__counter';

  overlay.appendChild(lbCloseBtn);
  overlay.appendChild(lbPrevBtn);
  overlay.appendChild(lbNextBtn);
  overlay.appendChild(lbImg);
  overlay.appendChild(lbCounter);
  document.body.appendChild(overlay);

  function showLbImage() {
    lbImg.src = lbGallery[lbIndex] || '';
    lbCounter.textContent = lbGallery.length > 1 ? (lbIndex + 1) + ' / ' + lbGallery.length : '';
    lbPrevBtn.style.display = lbGallery.length > 1 ? '' : 'none';
    lbNextBtn.style.display = lbGallery.length > 1 ? '' : 'none';
  }

  function lbPrev() {
    if (!overlay.classList.contains('is-visible') || lbGallery.length < 2) return;
    lbIndex = (lbIndex - 1 + lbGallery.length) % lbGallery.length;
    showLbImage();
  }

  function lbNext() {
    if (!overlay.classList.contains('is-visible') || lbGallery.length < 2) return;
    lbIndex = (lbIndex + 1) % lbGallery.length;
    showLbImage();
  }

  function openLightbox(images, startIndex) {
    lbGallery = Array.isArray(images) ? images : [images];
    lbIndex   = startIndex || 0;
    showLbImage();
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { lbImg.src = ''; lbGallery = []; }, 200);
  }

  lbCloseBtn.addEventListener('click', closeLightbox);
  lbPrevBtn.addEventListener('click', function (e) { e.stopPropagation(); lbPrev(); });
  lbNextBtn.addEventListener('click', function (e) { e.stopPropagation(); lbNext(); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeLightbox(); });

  /* ── Touch swipe for lightbox ─────────────────────────── */
  var lbTouchStartX = 0;
  var lbTouchStartY = 0;
  overlay.addEventListener('touchstart', function (e) {
    lbTouchStartX = e.touches[0].clientX;
    lbTouchStartY = e.touches[0].clientY;
  }, { passive: true });
  overlay.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - lbTouchStartX;
    var dy = e.changedTouches[0].clientY - lbTouchStartY;
    if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return; // 縦スクロールや微動は無視
    if (dx < 0) { lbNext(); } else { lbPrev(); }
  }, { passive: true });

  function attachGalleryBtns(root) {
    (root || document).querySelectorAll('.b2b-img-more').forEach(function (btn) {
      if (btn.dataset.galleryBound) return;
      btn.dataset.galleryBound = '1';
      btn.addEventListener('click', function () {
        const container = btn.closest('.b2b-product-info__images');
        if (!container) return;
        const raw = container.dataset.allImages || '';
        const images = raw.split('|').filter(Boolean);
        if (images.length) openLightbox(images, 3);
      });
    });
  }

  attachGalleryBtns();

  function attachImageClicks(root) {
    (root || document).querySelectorAll('.b2b-product-info__img').forEach(function (el) {
      if (el.dataset.lightboxBound) return;
      el.dataset.lightboxBound = '1';
      el.addEventListener('click', function () {
        const container = el.closest('.b2b-product-info__images');
        const raw = container ? container.dataset.allImages || '' : '';
        const images = raw.split('|').filter(Boolean);
        const src = el.dataset.full || el.src;
        const idx = images.indexOf(src);
        if (images.length) {
          openLightbox(images, idx >= 0 ? idx : 0);
        } else {
          openLightbox([src], 0);
        }
      });
    });
  }

  attachImageClicks();

})();
